import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GoogleTagManager } from "@next/third-parties/google";
import Script from "next/script";
export function GoogleTag({ gtmId, gtmCustomParams }) {
    if (!gtmId) {
        return null;
    }
    const params = gtmCustomParams ? JSON.parse(gtmCustomParams) : null;
    return (_jsxs(_Fragment, { children: [_jsx(Script, { strategy: "beforeInteractive", "data-cookieconsent": "ignore", children: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag() {
                        dataLayer.push(arguments);
                    }
                    gtag("consent", "default", {
                        ad_personalization: "granted",
                        ad_storage: "granted",
                        ad_user_data: "granted",
                        analytics_storage: "granted",
                        functionality_storage: "denied",
                        personalization_storage: "denied",
                        security_storage: "granted",
                        wait_for_update: 500,
                    });
                    gtag("set", "ads_data_redaction", true);
                    gtag("set", "url_passthrough", false);
                    ${params ? `gtag("set", ${JSON.stringify(params)});` : ``}
                ` }), _jsx(GoogleTagManager, { gtmId: gtmId, dataLayerName: "dataLayer" })] }));
}
